import Typography from "@mui/material/Typography";
import TextFieldStyled from "@/components/TextFieldStyled";

const NetworkLocationFormProberaumzentren = ({onChange}) => {

    const handleInputChanged = (event, value) => {
        if (onChange && typeof onChange === "function") {
            onChange(event, value);
        }
    }

    return (
        <>
            <Typography variant="h4" component="p" color="common.black" sx={{ mt: 4,}}>
                Orts-spezifische Angaben (Proberaumzentren)
            </Typography>
            <TextFieldStyled
                type="number"
                name="rooms"
                label="Anzahl der Räume"
                placeholder="25"
                onChange={handleInputChanged}
            />
        </>
    )
}

export default NetworkLocationFormProberaumzentren;
